var _g, _circle, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGambling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_113)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1004_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473 141L143 141L143 471L473 471L473 141ZM225.5 416C210.283 416 198 403.717 198 388.5C198 373.283 210.283 361 225.5 361C240.717 361 253 373.283 253 388.5C253 403.717 240.717 416 225.5 416ZM225.5 251C210.283 251 198 238.717 198 223.5C198 208.283 210.283 196 225.5 196C240.717 196 253 208.283 253 223.5C253 238.717 240.717 251 225.5 251ZM308 333.5C292.783 333.5 280.5 321.217 280.5 306C280.5 290.783 292.783 278.5 308 278.5C323.217 278.5 335.5 290.783 335.5 306C335.5 321.217 323.217 333.5 308 333.5ZM390.5 416C375.283 416 363 403.717 363 388.5C363 373.283 375.283 361 390.5 361C405.717 361 418 373.283 418 388.5C418 403.717 405.717 416 390.5 416ZM390.5 251C375.283 251 363 238.717 363 223.5C363 208.283 375.283 196 390.5 196C405.717 196 418 208.283 418 223.5C418 238.717 405.717 251 390.5 251Z",
    fill: "#FCFCFC"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white",
    transform: "translate(99 106)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1004_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 440,
    fill: "white",
    transform: "translate(88 86)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGambling);
export default __webpack_public_path__ + "static/media/gambling.2657ee578b42fcea52996abc5d13e93d.svg";
export { ForwardRef as ReactComponent };